import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  SimpleChanges,
} from "@angular/core";
import { SocketService, Constants } from "../../../../providers";
import { Subscription } from "rxjs";

@Component({
  selector: "brightness-actuator",
  templateUrl: "brightness-actuator.html",
})
export class BrightnessActuatorComponent {
  @Output() endpointChange: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateName: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateNotification: EventEmitter<any> = new EventEmitter();

  @Input() device: any;
  @Input() endpoint: any;
  @Input() updatedName: any;
  @Input() updatedNotification: any;

  @ViewChild("rangeSlider", { read: ElementRef }) _rangeRef: ElementRef;

  public data: any;
  private ioMeasure$: Subscription;

  private currentClick;

  public TYPE_ENDPOINTS: any = Constants.TYPE_ENDPOINTS;

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    this.data = { ...this.endpoint };
    if (!this.data.current) {
      this.data.current = 0;
    }

    this.initSocketIO();
  }

  ngAfterViewInit() {
    if (this.endpoint.id.includes(this.TYPE_ENDPOINTS.DALI_ID)) {
      this._rangeRef.nativeElement.querySelector(
        ".range-pin"
      ).textContent = this.data.current > 84 ? `${Math.round(
        ((this.data.current - 84) * 100) /
          (this.data.value[0].max - 85)
      )}` : 0;
    } else {
      this._rangeRef.nativeElement.querySelector(
        ".range-pin"
      ).textContent = `${Math.round(
        ((this.data.current) * 100) /
          (this.data.value[0].max)
      )}`;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.updatedName) {
      if (!changes.updatedName.currentValue) {
        return;
      }
      const dataEntry = changes.updatedName.currentValue;
      if (
        this.data._id === dataEntry.endpoint &&
        this.device._id === dataEntry.device
      ) {
        this.data.display_name = dataEntry.currentName;
      }
    }
  }

  initSocketIO() {
    this.ioMeasure$ = this.socketService
      .onMeasureCreated()
      .subscribe((measure: any) => {
        this.updateMeasure(measure);
      });
  }

  updateMeasure(measure: any) {
    if (
      measure.device !== this.device._id ||
      measure.endpoint !== this.data._id
    ) {
      return;
    }
    this.data.current = measure.value;
  }

  onChangeDimmer(value) {
    this.data.current = value;
    this.currentClick = Date.now();

    if (this.endpoint.id.includes(this.TYPE_ENDPOINTS.DALI_ID)) {
      this._rangeRef.nativeElement.querySelector(
        ".range-pin"
      ).textContent = this.data.current > 84 ? `${Math.round(
        ((this.data.current - 84) * 100) /
          (this.data.value[0].max - 85)
      )}` : 0;
    } else {
      this._rangeRef.nativeElement.querySelector(
        ".range-pin"
      ).textContent = `${Math.round(
        ((this.data.current) * 100) /
          (this.data.value[0].max)
      )}`;
    }


    setTimeout(() => {
      if (Date.now() - this.currentClick > 1000) {
        let myValue;
        if (this.endpoint.id.includes(this.TYPE_ENDPOINTS.DALI_ID)) {
          myValue = this.data.current == 84 ? 0 : this.data.current;
        } else {
          myValue = this.data.current;
        }
        this.endpointChange.emit({
          updated: true,
          _id: this.data._id,
          value: myValue,
        });
      }
    }, 1000);
  }

  updateName() {
    this.endpointUpdateName.emit({
      device: this.device._id,
      endpoint: this.data._id,
      currentName: this.data.display_name,
    });
  }

  ngOnDestroy() {
    if (this.ioMeasure$) {
      this.ioMeasure$.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/node-actuator/actuators/brightness-actuator/brightness-actuator.ts